import { Formik, Form } from 'formik';
import { useEffect, useRef } from 'react';
import theme from '../../../utils/themes';
import { StyledLabel } from '../../Campaigns/CampaignDetails';
import { useGetMultiposterJobBoardsMutation, useJobboardIntegrationMutation } from '../../Products/productApiSlice';
import FormikAsyncSelect from '../../../app/components/formikComponents/FormikAsyncSelect';
import FormikInputField from '../../../app/components/formikComponents/FormikInputField';
import * as Yup from 'yup';
import StyledButton from '../../../app/components/styledComponents/StyledButton';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';

const DynamicFormSection = ({ refetch, companyJobboards }) => {
  const { compId } = useParams();
  const formRef = useRef();
 const [getJobBoards] = useGetMultiposterJobBoardsMutation();
  const [connectJobBoard,{isLoading:loading}] = useJobboardIntegrationMutation();
  const handleSubmit = (values) =>{
    const exists = companyJobboards && companyJobboards?.jobBoards?.length > 0 && companyJobboards?.jobBoards?.some(item => item?.jobBoard?.accessKey === values?.jobBoard?.accessKey);
    if(exists){
      toast.error('Jobboard already connected');
    }
    else{
    const data=
    {companyId:compId,
   jobBoardDetails: [{userName:values?.username,
      jobBoardId:values?.jobBoard?.value,
      jobBoardAccessKey:values?.jobBoard?.accessKey,
      password:values?.password,
      postingKey:values?.postingKey
    }]
  }
  connectJobBoard(data).unwrap().then((res)=>{
  toast.success(res?.message || 'Jobboard connected successfully');
formRef?.current?.setFieldValue('jobBoard', {});
formRef?.current?.setFieldValue('username', '');
formRef?.current?.setFieldValue('password', '');
formRef?.current?.setFieldValue('postingKey', '');
  refetch();
  })
}
  }

  return (
    <div className="mb-4 rounded ">
      <Formik
        innerRef={formRef}
        initialValues={{
          jobBoard:{},
          username:'',
          password:'',
          postingKey:''
        }}
        validationSchema={Yup.object().shape(
          {
   password: Yup.string(),
   postingKey: Yup.string(),
   username: Yup.string().required('Required'),
   jobBoard: Yup.object().required('Required').nullable(),
 }
        )}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({values,setFieldValue}) =>   (
          <Form>
            <div className='row'>
               <div className="col-md-4 mb-3">
  <StyledLabel size={'14px'} weight={600} color={theme.headingColor} className='pb-1'>
    Jobboards
  </StyledLabel>

  <div className="position-relative">
    {isEmpty(values?.jobBoard) && <div className="position-absolute top-50 start-0 translate-middle-y ps-2 text-muted" style={{ zIndex: 1, pointerEvents: 'none' }}>
      <span>Select</span>
    </div>}
      <FormikAsyncSelect
        apiCall={getJobBoards}
        name="jobBoard"
        id="jobBoard"
        type="jobBoards"
        placeholder="Select"
        onChange={(value) => {
          setFieldValue('jobBoard', value);
          setFieldValue('username', '');
          setFieldValue('password', '');
          setFieldValue('postingKey', '');
        }}
      />
 
  </div>
</div>

            </div>
             <div className='row'>
               <div className="col-md-4 mb-3">
                  <StyledLabel size={'14px'} weight={600} color={theme.headingColor} className='pb-1'>
                    Username
                  </StyledLabel>
                 <FormikInputField
            name="username"
            id="username"
            placeholder="Type Here"
          />
                        </div>
                       {values?.jobBoard?.accessKey !== 'REED' ? (
  <div className="col-md-4 mb-3">
    <StyledLabel size={'14px'} weight={600} color={theme.headingColor} className='pb-1'>
      Password
    </StyledLabel>
    <FormikInputField
      name="password"
      id="password"
      placeholder="Type Here"
    />
  </div>
) : (
  <div className="col-md-4 mb-3">
    <StyledLabel size={'14px'} weight={600} color={theme.headingColor} className='pb-1'>
      Posting Key
    </StyledLabel>
    <FormikInputField
      name="postingKey"
      id="postingKey"
      placeholder="Type Here"
    />
  </div>
)}
            </div>
             <div className='d-flex justify-content-end'>
               <StyledButton
          className="me-3 py-2"
          variant={'primary'}
          type="submit"
          loading={loading}
          disabled={loading}
        >
          Connect
        </StyledButton>
        </div>
          </Form>
        )}
        
      </Formik>
    </div>
    
  );
};

export default DynamicFormSection;
